export const getStaleRealmRedirect = (
  pathname: string,
  userData?: { realm: string } | null
): string | null => {
  if (/(\/login|\/oauth)/.test(pathname)) {
    return null;
  }

  if (userData?.realm) {
    return `/${userData.realm}/operation/build/pipelines`;
  }

  return null;
};
